import React, { useEffect, useState, useCallback } from "react";
import { Box, Typography, Button } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import { useParams, useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import { fetchProductFunctions, fetchProductCategory } from "../../api/companyApi";
import { useNotification } from "../../providers/NotificationProvider";

export default function ProductFunctionListPage() {
  const { businessDomainId, businessUnitId, categoryId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });

  const [rows, setRows] = useState([]);
  const [categoryName, setCategoryName] = useState("");

  const basePath = `/strategy/${businessDomainId}/business-units/${businessUnitId}/product-categories/${categoryId}`;

  const loadData = useCallback(async () => {
    try {
      const [funcs, cat] = await Promise.all([
        fetchProductFunctions(categoryId),
        fetchProductCategory(categoryId),
      ]);
      setCategoryName(cat.productCategoryName || "");
      setRows(Array.isArray(funcs) ? funcs : []);
    } catch (e) { notify.apiError(e); }
  }, [categoryId]);

  useEffect(() => { loadData(); }, [loadData]);

  const columns = [
    {
      field: "productFunctionName",
      headerName: t("productFunction.name"),
      flex: 1,
      minWidth: 200,
    },
    {
      field: "productTaskName",
      headerName: t("productFunction.productTask"),
      width: 200,
    },
    {
      field: "functionName",
      headerName: t("productFunction.function"),
      width: 200,
    },
  ];

  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
        <Typography variant="h6">{categoryName}：{t("productFunction.list.title")}</Typography>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => navigate(`${basePath}/product-functions/create`)}
        >
          {t("common.add")}
        </Button>
      </Box>

      <Box sx={{ height: 400 }}>
        <DataGrid
          rows={rows}
          columns={columns}
          getRowId={(row) => row.productFunctionId}
          onRowClick={(params) =>
            navigate(
              `${basePath}/product-functions/${params.row.productFunctionId}`,
              { state: { functionData: params.row } }
            )
          }
          hideFooterSelectedRowCount
        />
      </Box>

      <Box sx={{ mt: 2 }}>
        <Button variant="outlined" onClick={() => navigate(basePath)}>{t("common.back")}</Button>
      </Box>
    </Box>
  );
}
